import { createContext } from 'react';
import type { ConfigurationContextType } from './types';

const ConfigurationContext = createContext<ConfigurationContextType>(
  {} as ConfigurationContextType,
);

export default ConfigurationContext;
